module.exports = __webpack_public_path__ + "media/images/editorial_board_icons/eb_barker_sm-7ab38500dc2133aad92df94eb248d122.png";